import React from 'react';
import { Helmet } from 'react-helmet';
import './pagestyles/RedboxTV.css';

const RedboxTV = () => {
  return (
    <>
      <Helmet>
        <title>Redbox TV+ - Premium Streaming & Live Business News | Redbox Global</title>
        <meta name="description" content="Stream live business news, exclusive interviews, market analysis shows, and premium video content on Redbox TV+. Your destination for real-time financial insights." />
        <meta name="keywords" content="Redbox TV+, streaming service, live business news, financial TV, market analysis, business shows, live interviews, premium streaming, business television" />
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://redboxglobal.com/redbox-tv" />
        <meta property="og:title" content="Redbox TV+ - Premium Streaming & Live Business News | Redbox Global" />
        <meta property="og:description" content="Stream live business news, exclusive interviews, and premium video content on Redbox TV+." />
        <meta property="og:image" content="https://images.unsplash.com/photo-1522869635100-9f4c5e86aa37?w=1200&h=630&fit=crop" />
        
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content="https://redboxglobal.com/redbox-tv" />
        <meta name="twitter:title" content="Redbox TV+ - Premium Streaming & Live Business News | Redbox Global" />
        <meta name="twitter:description" content="Stream live business news, exclusive interviews, and premium video content on Redbox TV+." />
        <meta name="twitter:image" content="https://images.unsplash.com/photo-1522869635100-9f4c5e86aa37?w=1200&h=630&fit=crop" />
        
        {/* Additional SEO */}
        <meta name="robots" content="index, follow" />
        <meta name="author" content="Redbox Global" />
        <link rel="canonical" href="https://redboxglobal.com/redbox-tv" />
      </Helmet>
      
      <div className="page-container">
        <div className="page-header">
          <h1>Redbox TV+</h1>
          <p className="page-subtitle">Stream live business news, exclusive shows, and premium financial content</p>
        </div>
        
        <div className="page-content">
          <a href="/article/markets-live-show" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
            <div className="featured-article">
              <div className="featured-image">
                <img src="https://images.unsplash.com/photo-1522869635100-9f4c5e86aa37?w=1200&h=600&fit=crop" alt="TV studio" />
              </div>
              <div className="featured-content">
               
                <h2>Markets Now: Live Trading Floor Coverage</h2>
                <p>Watch real-time market analysis with expert traders, live interviews with CEOs, and breaking financial news as it happens. Streaming daily from 9 AM to 4 PM ET.</p>
                <span className="article-meta">Live Daily • Weekdays</span>
              </div>
            </div>
          </a>

          <div className="content-grid">
            <a href="/article/ceo-spotlight-series" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
              <article className="article-card">
                <div className="article-image">
                  <img src="https://images.unsplash.com/photo-1557804506-669a67965ba0?w=600&h=400&fit=crop" alt="CEO interviews" />
                </div>
                <div className="article-content">
                 
                  <h2>CEO Spotlight: Leadership Conversations</h2>
                  <p>Exclusive one-on-one interviews with top executives shaping the business world.</p>
                  <span className="article-meta">Weekly Series</span>
                </div>
              </article> 
            </a> 

            <a href="/article/tech-trends-show" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
              <article className="article-card">
                <div className="article-image">
                  <img src="https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=600&h=400&fit=crop" alt="Tech show" />
                </div>
                <div className="article-content">
                 
                  <h2>Tech Forward: Innovation Unpacked</h2>
                  <p>Exploring breakthrough technologies and the startups disrupting industries.</p>
                  <span className="article-meta">Bi-Weekly</span>
                </div>
              </article>
            </a>

            <a href="/article/global-markets-roundup" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
              <article className="article-card">
                <div className="article-image">
                  <img src="https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=600&h=400&fit=crop" alt="Global markets" />
                </div>
                <div className="article-content">
                  
                  <h2>Global Markets Roundup</h2>
                  <p>Your daily wrap-up of international markets, currencies, and commodities.</p>
                  <span className="article-meta">Daily • 5 PM ET</span>
                </div>
              </article>
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default RedboxTV;
